import React, { useEffect, useState } from "react";
import { Box, Button, List, ListItem, Typography } from "@mui/material";
import { useCourseHoleNumber, useCourseScoreCardDetails } from "hooks/CourseMapDetails";
import asset from "json/assets";
import events from "json/events";
import Draggable from "react-draggable";
import eventEmitter from "services/event.emitter";
import styles from "styles/component/CustomCoursePopOver.module.scss";
import _style from "styles/component/CourseScoreCardPopOver.module.scss";
import * as _ from "underscore";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import LaunchIcon from '@mui/icons-material/Launch';

const CourseScoreCardPopOver = (props) => {
  const { title = "Scorecard Info" } = props;
  const holeNumber = useCourseHoleNumber();
  const ScoreCardDetails = useCourseScoreCardDetails();
  const [open, setOpen] = useState(false);
  const [selectedTeeData, setSelectedTeeData] = useState([]);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const courseIdFromQuery = searchParams.get("course");

  const handleClose = () => {
    setOpen(false);
  };

  eventEmitter.on(events.openScoreCardInfoModal, (e) => {
    setOpen(e.visible);
  });
  useEffect(() => {
    let teesList = ScoreCardDetails?.teesList; 
    let teeData = [];
    if (teesList && teesList.length > 0) {
      for (let i = 0; i < 5; i++) {
        if(teesList[i]?.ydsHole[holeNumber - 1]){
          teeData.push({
            value: teesList[i]?.ydsHole[holeNumber - 1],
            color: `#${teesList[i]?.teeColorValue}`,
          });
        }
      }
    }
    setSelectedTeeData(teeData);
    return () => {};
  }, [holeNumber, ScoreCardDetails]);

  return (
    <Box className={`${styles.sub_popover} ${styles.draggableDiv}`}>
      <Draggable
        bounds={"#DraggableContainer"}
        defaultPosition={{ x: 400, y: 0 }}
        // key={Math.random()} //  resets the dragged modal to initial position on load ~ new key=> new DOM change
      >
        <Box
          className={`${styles.poover_content} ${styles.default_poover_content} custom_popover_content`}
          sx={{ opacity: open ? "1" : "0", display: open ? "block" : "none" }}
        >
          <Box className={styles.poover_head} display="flex" alignItems="center" justifyContent="space-between">
             <Box display="flex" alignItems="center">
            <Typography variant="h5" sx={{ margin: 0, padding: 0, lineHeight: 1 }}>{title}</Typography>
              <LaunchIcon 
     onClick={()=> navigate(`/scoreDetails/course?courseId=${courseIdFromQuery}`)}
    sx={{
      color: "white",
      cursor: "pointer",
      ml: 0.6,
      fontSize: 19, 
      verticalAlign: "middle",
    }}
    />
    </Box>
            <List>
              <ListItem>
                <Button onClick={handleClose}>
                  <img src={asset.close} alt="" />
                </Button>
              </ListItem>
            </List>
          </Box>

          <Box className={`${styles.popover_ftr} ${_style.popover_scorecard}`}>
            <table id={"list_table"} className={_style.score_table}>
              <thead>
                <tr>
                  <td>{`Hole ${holeNumber || ''}`}</td> 
                  {_.map(selectedTeeData, (tee, key) => {
                    return (
                      <td>
                        {" "}
                        <Box
                          className={_style.color_box}
                          sx={{ backgroundColor: tee?.color }}
                        />{" "}
                      </td>
                    );
                  })}
                </tr>
                <tr>
                  <td>Yards</td>

                  {_.map(selectedTeeData, (tee, key) => {
                    return <td>{tee?.value}</td>;
                  })}
                </tr>
              </thead>
            </table>

            {/* <Button to={"#"} className={styles.blue_btn} onClick={() => {}}>
            Save
          </Button> */}
          </Box>
        </Box>
      </Draggable>
    </Box>
  );
};

export default CourseScoreCardPopOver;
